import loadScript from "load-script"
import React, { Component } from "react"
import { GooglePickerResult } from "../../libs/GooglePickerResult"

const GOOGLE_PICKER_API_KEY = "AIzaSyCqPWEUO0CAtpVu68ga7tipGt7QnqN8YMk"
const GOOGLE_PICKER_CLIENT_ID =
  "431887460170-ripbvtdcvb8guo1plugvctu46ivhokfm.apps.googleusercontent.com"
const GOOGLE_SDK_URL = "https://apis.google.com/js/api.js"
const STORAGE_KEY = "bl-picker-oauth-token"

interface Props {
  onPickPhotos: (data: GooglePickerResult) => void
  disabled: boolean
}

let scriptLoadingStarted = false

function getCameraSyncView() {
  const picker = google.picker as any
  const PhotosView = picker.PhotosView as any
  return new PhotosView().setType("camerasync")
}

export class GooglePhotoPicker extends Component<Props> {
  public static defaultProps: Props = {
    // tslint:disable-next-line: no-empty
    onPickPhotos: () => {},
    disabled: false
  }

  constructor(props: any) {
    super(props)
    this.onApiLoad = this.onApiLoad.bind(this)
    this.onChoose = this.onChoose.bind(this)
  }

  componentDidMount() {
    if (this.isGoogleReady()) {
      // google api is already exists
      // init immediately
      this.onApiLoad()
    } else if (!scriptLoadingStarted) {
      // ロードされてないときは描画をかえるとかしたほうがよい
      scriptLoadingStarted = true
      loadScript(GOOGLE_SDK_URL, this.onApiLoad)
    } else {
      // is loading
    }
  }

  get storageOAuthToken(): string | null {
    return window.localStorage.getItem(STORAGE_KEY)
  }

  set storageOAuthToken(key: string | null) {
    if (key !== null) {
      window.localStorage.setItem(STORAGE_KEY, key)
    } else {
      window.localStorage.removeItem(STORAGE_KEY)
    }
  }

  isGoogleReady() {
    return !!window.gapi
  }

  isGoogleAuthReady() {
    return !!window.gapi.auth
  }

  isGooglePickerReady() {
    return !!window.google.picker
  }

  onApiLoad() {
    window.gapi.load("auth", d => console.log("google auth load", d))
    window.gapi.load("picker", d => console.log("google picker load", d))
  }

  doAuth(callback: (token: GoogleApiOAuth2TokenObject) => void): void {
    const arg = {
      immediate: false,
      client_id: GOOGLE_PICKER_CLIENT_ID,
      scope: ["https://www.googleapis.com/auth/photos"]
    }
    window.gapi.auth.authorize(arg, callback)
  }

  async onChoose() {
    if (
      !this.isGoogleReady() ||
      !this.isGoogleAuthReady() ||
      !this.isGooglePickerReady() ||
      this.props.disabled
    ) {
      return null
    }

    let oauthToken
    if (this.storageOAuthToken) {
      const url = `https://www.googleapis.com/oauth2/v1/tokeninfo?access_token=${this.storageOAuthToken}`
      // console.log(url);
      try {
        const res = await fetch(url)
        const json = await res.json()
        if (json.error) {
          throw new Error("json error")
        } else {
          console.log("valid oAuth token from localstorage", json)
          oauthToken = this.storageOAuthToken
        }
      } catch (e) {
        console.log("invalid oAuth token!")
        this.storageOAuthToken = null
      }
    }

    if (!oauthToken) {
      const token = window.gapi.auth.getToken()
      // console.log("TOKEN", token);
      oauthToken = token && token.access_token
      this.storageOAuthToken = oauthToken = token && token.access_token
    }

    if (oauthToken) {
      this.createPicker(oauthToken)
    } else {
      this.doAuth(response => {
        // console.log("DO OAUTH", response);
        if (response.access_token) {
          this.storageOAuthToken = response.access_token
          this.createPicker(response.access_token)
        } else {
          this.storageOAuthToken = null
          // console.log("oauth failed: ", response);
        }
      })
    }
  }

  createPicker(accessToken: string) {
    // const googleViewId = google.picker.ViewId["PHOTOS"];
    const pickupPhotos = (data: GooglePickerResult) => {
      this.props.onPickPhotos(data)
    }
    const cameraSyncView = getCameraSyncView()
    const picker = new google.picker.PickerBuilder()
      .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
      // .enableFeature(google.picker.Feature.NAV_HIDDEN)
      .addView(cameraSyncView)
      .addView(google.picker.ViewId.PHOTOS)
      .addView(google.picker.ViewId.PHOTO_UPLOAD)
      // .setLocale("ja")
      .setOAuthToken(accessToken)
      .setDeveloperKey(GOOGLE_PICKER_API_KEY)
      .setOrigin(window.location.protocol + "//" + window.location.host)
      .setCallback((data: any) => {
        if (
          data[google.picker.Response.ACTION] === google.picker.Action.PICKED
        ) {
          pickupPhotos(data)
        }
      })

    picker.build().setVisible(true)
  }

  render() {
    return (
      <div onClick={this.onChoose}>
        <a
          className="button is-rounded bl-editor__main-add-button"
          style={{ padding: 24 }}
        >
          <span className="icon" style={{ width: 0 }}>
            <i className="fa fa-lg fa-plus has-text-grey"></i>
          </span>
        </a>
      </div>
    )
  }
}
